<template>
  <v-menu
    offset-overflow
    absolute
    :value="true"
    :position-y="position.y"
    :position-x="position.x"
    :close-on-content-click="false"
    @input="$emit('close')"
    >
    <v-card>
      <v-layout pa-2 row>
         <span>URL: </span>
          <a :href="value.url"
             class="overflow-x-hidden ml-1"
             style="text-overflow: ellipsis"
             target="_blank">{{value.url}}</a>
        <a class="pl-2 pr-2" @click="editBlot">
          {{ $t('message.editor.tooltip.nxLink.edit')}}
        </a>
        <v-divider vertical ></v-divider>
        <a class="pl-2" @click="remove">
          {{ $t('message.editor.tooltip.nxLink.remove')}}
        </a>
      </v-layout>
    </v-card>
  </v-menu>

</template>

<script>
import AdvancedLink from '@/components/texteditor/advanced/blots/advancedLinkInline';
import config from '@/components/texteditor/config/advanced';
import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';

export default {
  props: {
    position: Object,
    value: Object,
    quill: Object,
  },
  methods: {
    remove() {
      const range = this.quill.getSelection() ? this.quill.getSelection() : this.quill.selection.savedRange;
      const [link, offset] = this.quill.scroll.descendant(
        AdvancedLink,
        range.index,
      );
      const linkRange = { index: range.index - offset, length: link.length() };
      this.quill.removeFormat(linkRange.index, linkRange.length);
      this.$emit('close');
    },
    editBlot() {
      const range = this.quill.getSelection() ? this.quill.getSelection() : this.quill.selection.savedRange;
      const [link, offset] = this.quill.scroll.descendant(
        AdvancedLink,
        range.index,
      );
      const linkRange = { index: range.index - offset, length: link.length() };
      const text = this.quill.getText(linkRange.index, linkRange.length);
      const dialogConfig = config.toolbar['ql-advanced-link'];
      const message = {
        uuid: this.quill.uuid,
        params: {
          dialogConfig,
          fields: {
            text,
            entity: this.value,
            range: linkRange,
          },
        },
      };
      this.$emit('close');
      QuillEventBus.$emit(QuillEvents.CREATE, message);
    },
  },
};
</script>
<style scoped>
  a {
    color: #06c;
  }
</style>
